import './scss/reset.scss'
import './scss/variables.scss'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Homepage from './pages/Homepage'
import Stanze from './pages/Stanze'
import Create from './pages/Create';
import Maths from './pages/Subjects/Maths'
import Physics from './pages/Subjects/Physics'
import It from './pages/Subjects/It'
import English from './pages/Subjects/English'
import Literacy from './pages/Subjects/Literacy'
import Others from './pages/Subjects/Others'
import Chi_siamo from './pages/Chi_siamo'
import Supportaci from './pages/Supportaci'
import Progetto from './pages/Progetto'
import Community from './pages/Community'
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Join from './pages/Join'


function App() {
  return (

    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/" exact component={Homepage}></Route>
        <Route path="/stanze" component={Stanze}></Route>
        <Route path="/create" component={Create}></Route>
        <Route path="/join" component={Join}></Route>

        <Route path="/maths" component={Maths}></Route>
        <Route path="/physics" component={Physics}></Route>
        <Route path="/it" component={It}></Route>
        <Route path="/english" component={English}></Route>
        <Route path="/literacy" component={Literacy}></Route>
        <Route path="/others" component={Others}></Route>

        <Route path="/chi-siamo" component={Chi_siamo}></Route>
        <Route path="/supportaci" component={Supportaci}></Route>
        <Route path="/progetto" component={Progetto}></Route>
        <Route path="/community" component={Community}></Route>
        
      </Switch>
    </Router>
  
  )
}

export default App;